import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "../../util/DateConvertor";

export class UserService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getUsersList(page, size, fullNameFilter, phoneNumberFilter) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/users`,
                {
                    page,
                    size,
                    "full-name": fullNameFilter,
                    "phone-number": phoneNumberFilter,
                }
            ).then(resolve).catch(reject)
        })
    }

    getUserInformation(userId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/users/${userId}/information`,
            ).then(resolve).catch(reject)
        })
    }

    updateUserInformation(userId, firstName, lastName, phoneNumber, nationalCode, gender, birthDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/users/${userId}/information`,
                {
                    firstName,
                    lastName,
                    nationalCode,
                    gender,
                    birthDate: convertPersianDateToUniversalDate(birthDate)
                }
            ).then(resolve).catch(reject)
        })
    }

    getUserEnabled(userId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/users/${userId}/enabled`,
            ).then(resolve).catch(reject)
        })
    }

    updateUserEnabled(userId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/users/${userId}/enabled`,
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

}